import axiosInstance from '@/api/axiosInstance'

export default {
  getInvitations(token) {
    return axiosInstance.get('/invitations', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  // TODO change url
  getInvitationsCount(token) {
    return axiosInstance.get('/invitations', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  acceptInvitation(invitationId, token) {
    return axiosInstance.post(
      '/accepts',
      {
        invitationId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
  },
  rejectInvitation(invitationId, token) {
    return axiosInstance.post(
      '/declines',
      {
        invitationId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
  }
}
